/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/camelcase */
/** ============================ */
/*  This file was autogenerated  */
/*  with `npm run codegen`       */
/* ============================= */

import { gql } from "@apollo/client";
import * as ApolloReactCommon from "@apollo/client";
import * as ApolloReactHooks from "@apollo/client";

import * as Types from "../../../api/types.generated";
export type GetHardwareLotteryEntriesQueryVariables = Types.Exact<{
  sku_code: Types.Scalars["String"];
  event_id: Types.Scalars["Float"];
}>;

export type GetHardwareLotteryEntriesQuery = {
  hardwareLotteryEntries: Array<
    Pick<
      Types.HardwareLotteryEntry,
      | "id"
      | "status"
      | "user_id"
      | "event_id"
      | "sku_code"
      | "created_at"
      | "updated_at"
      | "hardware_request_id"
    > & {
      user: Pick<Types.User, "id" | "name" | "email">;
      sku: Pick<Types.HardwareSku, "code" | "name">;
      event: Pick<Types.Event, "id" | "name">;
    }
  >;
};

export const GetHardwareLotteryEntriesDocument = gql`
  query GetHardwareLotteryEntries($sku_code: String!, $event_id: Float!) {
    hardwareLotteryEntries(sku_code: $sku_code, event_id: $event_id) {
      id
      status
      user_id
      event_id
      sku_code
      created_at
      updated_at
      hardware_request_id
      user {
        id
        name
        email
      }
      sku {
        code
        name
      }
      event {
        id
        name
      }
    }
  }
`;

/**
 * __useGetHardwareLotteryEntriesQuery__
 *
 * To run a query within a React component, call `useGetHardwareLotteryEntriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetHardwareLotteryEntriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetHardwareLotteryEntriesQuery({
 *   variables: {
 *      sku_code: // value for 'sku_code'
 *      event_id: // value for 'event_id'
 *   },
 * });
 */
export function useGetHardwareLotteryEntriesQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    GetHardwareLotteryEntriesQuery,
    GetHardwareLotteryEntriesQueryVariables
  >
) {
  return ApolloReactHooks.useQuery<
    GetHardwareLotteryEntriesQuery,
    GetHardwareLotteryEntriesQueryVariables
  >(GetHardwareLotteryEntriesDocument, baseOptions);
}
export function useGetHardwareLotteryEntriesLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    GetHardwareLotteryEntriesQuery,
    GetHardwareLotteryEntriesQueryVariables
  >
) {
  return ApolloReactHooks.useLazyQuery<
    GetHardwareLotteryEntriesQuery,
    GetHardwareLotteryEntriesQueryVariables
  >(GetHardwareLotteryEntriesDocument, baseOptions);
}
export type GetHardwareLotteryEntriesQueryHookResult = ReturnType<
  typeof useGetHardwareLotteryEntriesQuery
>;
export type GetHardwareLotteryEntriesLazyQueryHookResult = ReturnType<
  typeof useGetHardwareLotteryEntriesLazyQuery
>;
export type GetHardwareLotteryEntriesQueryResult =
  ApolloReactCommon.QueryResult<
    GetHardwareLotteryEntriesQuery,
    GetHardwareLotteryEntriesQueryVariables
  >;
